import { render, staticRenderFns } from "./typicons.vue?vue&type=template&id=6e8dcd61&"
import script from "./typicons.vue?vue&type=script&lang=js&"
export * from "./typicons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports